<!-- Circle of the active profile: its photo, or the initial of its name (reactive: follows the data store) -->
<script setup lang="ts">
import { computed } from 'vue'
import { useDataStore } from '../stores/data'
import { cssUrl } from '../utils/css'

const store = useDataStore()
const profile = computed(() => store.currentProfile())
const initial = computed(() => ((profile.value?.name || '').trim()[0] || 'P').toUpperCase())
</script>

<template>
  <span class="avatar rounded-full bg-brand bg-cover bg-center text-white flex items-center justify-center font-bold"
    :style="profile?.avatar ? { backgroundImage: cssUrl(profile.avatar) } : undefined">{{ profile?.avatar ? '' : initial }}</span>
</template>
